import React from "react";
import {
	AddlFieldType,
	NUMBER_OF_CUSTOM_COLUMNS_ORDER_ADDITIONAL_INFO,
	NUMBER_OF_CUSTOM_COLUMNS_ORDER_ADDITIONAL_INFO_MOBILE,
} from 'shared/constants/fields';
import { safeJsonParse } from "shared/utils/functions";
import useResponsive from './useResponsive';

export const useEntityDisplayName = (entityType) => {
  let conf = sessionStorage.getItem("entityDisplayNames");
  if (conf && entityType) {
		conf = JSON.parse(conf)[entityType];
		return [conf.singular, conf.plural];
  }
	return ['', ''];
};

export const usePortalView = (config = '') => {
  const conf = localStorage.getItem('portalView');
	const res = safeJsonParse(conf);
	if (res) return config ? res[config] : res;
	return res;
};

export const useFilteredFieldsConfigs = (configs = []) => {
	const data = Object.assign(filterEntity, { configs })
		.filterByAdditionalAttribute()
		.filterByType()
		.sortByOrder()
		.replaceSelectToMultiSelect();

	return data.configs;
};

const filterEntity = {
	filterByAdditionalAttribute: function () {
		this.configs = this.configs.filter(c => c.additionalAttribute);
		return this;
	},
	filterByType: function () {
		this.configs = this.configs.filter((c) =>
      [
        AddlFieldType.NUM,
        AddlFieldType.STR,
        AddlFieldType.SELECT,
        AddlFieldType.SELECT_MULTI,
      ].includes(c.fieldType)
    );
		return this;
	},
	sortByOrder: function () {
		this.configs = this.configs.sort(
			(a, b) =>
				Number.parseInt(a.portalOrder) -
				Number.parseInt(b.portalOrder)
		);
		return this;
	},
	replaceSelectToMultiSelect: function () {
		this.configs = this.configs.map(c => {
			if (c.fieldType === AddlFieldType.SELECT) {
				return {
					...c,
					fieldType: AddlFieldType.SELECT_MULTI,
				};
			}
			return c;
		});
		return this;
	},
};

export const useColsCount = () => {
	const { isMobile, isDesktop } = useResponsive();
	const [count, setCount] = React.useState(
		NUMBER_OF_CUSTOM_COLUMNS_ORDER_ADDITIONAL_INFO
	);
	React.useEffect(() => {
		if (isMobile) {
			setCount(NUMBER_OF_CUSTOM_COLUMNS_ORDER_ADDITIONAL_INFO_MOBILE);
			return;
		}
		if (isDesktop) {
			setCount(NUMBER_OF_CUSTOM_COLUMNS_ORDER_ADDITIONAL_INFO);
			return;
		}
	}, [isMobile, isDesktop]);

	return [count];
};
